if (!customElements.get('product-list-tabs')) {
  class ProductListTabs extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        this.buttons = Array.from(this.querySelectorAll('[data-collection]'));
        this.slider = document.getElementById(this.dataset.target);
        if (!this.slider || !this.buttons.length) return;

        this.productLimit = Number(this.slider.dataset.productLimit) || 6;
        this.collectionMap = new Map();
        this.cacheItems();

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-collection]');
          if (!button || !this.contains(button)) return;

          event.preventDefault();
          this.selectTab(button);
        });
      });
    }

    cacheItems() {
      this.slider.querySelectorAll('.columns[data-collection]').forEach((item) => {
        const handle = item.dataset.collection;
        if (!this.collectionMap.has(handle)) this.collectionMap.set(handle, []);
        this.collectionMap.get(handle).push(item);
      });
    }

    getFlickity() {
      return this.slider?._flkty || (window.Flickity ? window.Flickity.data(this.slider) : null);
    }

    selectTab(button) {
      this.buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      const handle = button.dataset.collection;
      if (this.collectionMap.has(handle)) {
        this.showCollection(handle);
        return;
      }

      this.fetchCollection(handle, button.dataset.collectionUrl).then(() => {
        this.showCollection(handle);
      });
    }

    showCollection(handle) {
      const items = this.collectionMap.get(handle) || [];

      this.slider.querySelectorAll('.columns[data-collection]').forEach((item) => {
        item.classList.remove('carousel__slide');
      });

      items.forEach((item) => item.classList.add('carousel__slide'));

      const flkty = this.getFlickity();
      if (!flkty) return;

      flkty.reloadCells();
      flkty.resize();
      flkty.select(0, false, true);

      requestAnimationFrame(() => {
        flkty.resize();
        this.resetArrowState(flkty);
      });
    }

    resetArrowState(flkty) {
      const prevButton = this.slider.querySelector('.flickity-prev');
      const nextButton = this.slider.querySelector('.flickity-next');
      const progressBar = this.slider.parentNode?.querySelector('.flickity-progress--bar');
      const slides = flkty.slides || [];
      const firstSlide = slides[0];
      const lastSlide = slides[slides.length - 1];
      const canMove = Boolean(
        firstSlide &&
        lastSlide &&
        Math.abs(lastSlide.target - firstSlide.target) > 1
      );

      if (prevButton) {
        prevButton.disabled = true;
        prevButton.classList.add('hide-arrow');
      }

      if (nextButton) {
        nextButton.disabled = !canMove;
        nextButton.classList.toggle('hide-arrow', !canMove);
      }

      if (progressBar) progressBar.style.width = '0%';
    }

    fetchCollection(handle, collectionUrl) {
      if (!collectionUrl) return Promise.resolve();

      const separator = collectionUrl.includes('?') ? '&' : '?';
      const url = `${collectionUrl}${separator}section_id=product-list-tab-ajax`;

      return fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = Array.from(
            doc.querySelectorAll('.columns[data-collection]')
          ).slice(0, this.productLimit + 1);
          const container = this.slider.querySelector('.flickity-slider') || this.slider;

          items.forEach((item) => container.appendChild(item));
          this.collectionMap.set(handle, items);

          items.forEach((item) => {
            item.querySelectorAll('.lazyload').forEach((image) => {
              window.lazySizes?.loader.unveil(image);
            });
          });
        })
        .catch(() => {
          this.collectionMap.set(handle, []);
        });
    }
  }

  customElements.define('product-list-tabs', ProductListTabs);
}
